import { DIR } from '@/services/localhost';


// ROOT
    export function rootAuth_set(token){
        localStorage.setItem(`rootAth_${DIR()}`, token);
    }

    export function rootAuth(){
        return localStorage.getItem(`rootAth_${DIR()}`);
    }

    export function rootAuth_remove(){
        localStorage.removeItem(`rootAth_${DIR()}`);
    }
// ROOT


// LOGOUT
    export function logout(ROUTER){
        ROUTER.push(`/login/logout/`);
    }
// LOGOUT
